/**
 * @description
 *
 * Асинхронно загружает скрипт через тэг `body`.
 *
 * @param {string} src - путь, откуда брать скрипт
 *
 * @returns { Promise } -
 */

function loadExternalScript(src) {
  return new Promise((resolve, reject) => {
    if (!src) {
      reject()
    }

    const script = document.createElement('script')

    script.async = true
    script.src = src

    script.onload = () => resolve()
    script.onerror = err => reject(err)

    document.body.appendChild(script)
  })
}

export default loadExternalScript
